<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：云仓-云仓管理-云仓详情
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="产品名称">
          <el-input v-model="formInline.product_name" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="addClick()" type="success" icon="el-icon-plus" v-auth="'/warehouse/warehouse/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--用户-->
    <div class="blue">用户：{{ nickName }} ( ID：{{ user_id }} ) 的云仓</div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product" label="产品图片" width="80">
            <template slot-scope="scope">
              <img v-img-url="scope.row.product.image[0].file_path" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="product.product_name" label="产品名称"></el-table-column>
          <el-table-column prop="product_number" label="云仓库存"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/warehouse/warehouse/edit'">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
      <!--操作-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">返回</el-button>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" :model="model" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :model="model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js';
  import Add from './dialog/Add.vue';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
      /*编辑组件*/
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          product_name: '',
        },
        model: [],
        user_id: 0,
        nickName: '',
        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
      };
    },
    created() {
      this.user_id = this.$route.query.user_id;
      this.nickName = this.$route.query.nickName;
      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        let model = [];
        model.user_id = self.user_id;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.model = model;
        // console.log(Params);
        WarehouseApi.getWarehouseDetail(Params, true)
        .then(res => {
         self.tableData = res.data.detail.data;
         self.totalDataNumber = res.data.detail.total;
         self.loading = false;
        })
        .catch(error => {
        });
      },

      /*打开添加*/
      addClick() {
        let arr = [];
        this.tableData.forEach(item => {
          arr.push(item.product_id);
        });
        this.model.excludeIds = arr;
        this.model.user_id = this.user_id;
        this.open_add = true;
      },
      //编辑
      editClick($row){
        this.model = $row;
        this.open_edit = true;
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },
      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
      /*取消*/
      cancelFunc() {
        /*存储缓存*/
        localStorage.setItem('activeName','first')
        this.$router.back(-1);
      }
      
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/warehouse/warehouse/detail.vue